import ApiService from './ApiService.js'
import ApiHelper from './ApiHelper.js'

export default {
    getByID(id) {
        let header = ApiHelper.getHeader();
        return ApiService().get('/api/projects/' + id,
            { 
                headers: header
            });
    },
    search(value) {
        let header = ApiHelper.getHeader();
        return ApiService().get('/api/projects/0/25?search=' + value,
            { 
                headers: header
            });
    }
}